/**
 * Obtiene el nombre de fichero a partir de una URI del servicio documental.
 */
export function getDocumentalFileName(uri: string): string {
  const parts = uri.split(":");
  const path = parts.length > 1 ? parts[1] : parts[0];
  const segments = path.split("/");
  const filename = segments.pop() || "";

  try {
    return decodeURIComponent(filename);
  } catch {
    return filename;
  }
}
